import { FormSection } from 'framework/ui/layout';
import { DocumentScanUploaderInput } from 'domain/shared/employee';
import { Permission } from 'infrastructure/security/authorization/davinciAuthorizationService';
import { UPDATE_EMPLOYEE_REQUISITES_INFORMATION, EMPLOYEE_TYPES_ALIAS } from 'domain/shared/employee';
import { FC } from 'react';
import { TextInput } from 'framework/form';

type RequisitesUpdateSectionProps = {
  isGranted: (permission: Permission | Permission[], contextName?: string) => boolean;
};

const RequisitesUpdateSection: FC<RequisitesUpdateSectionProps> = ({ isGranted }) => {
  return (
    <FormSection
      title="Requisites"
      isVisible={employee =>
        employee.employeeType === EMPLOYEE_TYPES_ALIAS.CONTRACTOR && isGranted(UPDATE_EMPLOYEE_REQUISITES_INFORMATION)
      }
    >
      <TextInput source="extendedInformation.requisitesInformation.requisites" label="Requisites" />
      <DocumentScanUploaderInput source="extendedInformation.requisitesInformation.scansIds" label="Document scans" />
    </FormSection>
  );
};

export { RequisitesUpdateSection };
